import { useNavigate } from 'react-router';
import { toast } from 'sonner';

import { SetPasswordForm, ISetPasswordForm } from 'src/components/Authentication';
import { useAuth } from 'src/context/auth/use-auth';

const SetPasswordContainer = () => {
  const { setNewPassword } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async ({ password }: Omit<ISetPasswordForm, 'confirmPassword'>) => {
    try {
      await setNewPassword(password);

      navigate('/');
    } catch (e: unknown) {
      if (e instanceof Error) toast.error(e.message || 'Something went wrong!');
    }
  };

  return <SetPasswordForm onSubmit={onSubmit} />;
};

export default SetPasswordContainer;
